import { Places } from '../../Constants'
import { MainKeys } from '../../main/Main.keys'

export class GrupoManualKeys extends MainKeys {
    public get place() {
        return Places.grupoManual
    }

    /** Aba aberta: 'empresa' (padrão) ou 'grupos'. */
    public get aba(): 'empresa' | 'grupos' {
        return this._intent.getParameterAsString('aba') === 'grupos' ? 'grupos' : 'empresa'
    }

    public set aba(value: 'empresa' | 'grupos') {
        this._intent.setParameter('aba', value === 'grupos' ? 'grupos' : null)
    }

    /** Empresa aberta na aba "por empresa", para recarregar a página sem perdê-la. */
    public get cnpj() {
        return (this._intent.getParameterAsString('cnpj') ?? '').replace(/\D/g, '')
    }

    public set cnpj(value: string) {
        this._intent.setParameter('cnpj', value || null)
    }
}

export default GrupoManualKeys
